export default __webpack_public_path__ + "static/media/third-background.f441f743.png";